var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header", style: { background: _vm.background } },
    [
      _c(
        "van-row",
        { attrs: { type: "flex" } },
        [
          _vm.isBack
            ? _c(
                "div",
                { staticClass: "back", on: { click: _vm.clickBack } },
                [
                  _vm.isBack
                    ? _c("van-icon", {
                        style: { color: _vm.iconColor },
                        attrs: { name: "arrow-left" }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "van-col",
            {
              staticClass: "center title",
              style: { color: _vm.color },
              attrs: { span: "24" }
            },
            [_vm._v("\n     " + _vm._s(_vm.title) + "\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af5d225e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af5d225e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = null
// module chunks = 